<template>
  <MenuContexto>
    <template #menu-de-opcoes>
      <div v-show="categorias_selecionadas && categorias_selecionadas.length > 0" class="bg-white">
        <v-list-item @click="atualizarCategoriasParaVincularAGruposProdutos">
          Vincular categorias a grupo de produtos
        </v-list-item>
      </div>
    </template>

    <SysDataTableDepartamentos
      ocultar_titulo
      :departamento="departamento_fake"
      :linhas_removidas="linhas_removidas"
      :qtd_niveis_expancao="2"
      :cabecalhos_personalizado="cabecalhos"
      :formatar_linhas="false"
      :height="VISAO_VERTICAL_ATIVA ? alturaDaJanela - 220 : alturaDaJanela - 513"
      ocultar_filtros_topo
      ocultar_tela_cheia
      :ocultar_filtro_pesquisa="categorias_selecionadas && categorias_selecionadas.length > 0"
      show-select
      ocultar_marcador_identacao
      titulo="Categorias"
      :callback-nivel1="buscarTotalizadorCategoriasCompra"
      :callback-nivel2="buscarCategoriasCompra"
      :item-class="classesCssLinha"
      @click:row="setCategoriaSelecionada"
      @callback-carregar-dados="setCallbackAtualizarGridCategorias"
      @itens-data-table="itens_grid = $event"
    >
      <template #prefixo.topo>
        <span class="mr-5 font-18">Categorias</span>
      </template>

      <template #append.topo>
        <div class="pt-2 pb-1">
          <AdicionarMultiplasCategoriasAoCarrinho
            :categorias="categorias_selecionadas"
            @categorias-adicionadas-carrinho="produtoAdicionadoNoCarrinho(categorias_selecionadas);"
          />

          <SilenciarCategoria
            v-if="categorias_selecionadas && categorias_selecionadas.length > 0"
            :idgrupo="Number(GRUPO_COMPRA)"
            :categorias="Helpers.arrayColumn(categorias_selecionadas, 'idcategoria')"
            @categorias-silenciadas="categoriasSilenciadas()"
          >
            <template #default="{ callback }">
              <v-btn color="red" dark small class="ml-6" @click.stop="callback">
                <v-icon :size="16" class="pr-1">mdi-bell-off</v-icon>
                silenciar
                <span class="qtde-top-button-small">{{categorias_selecionadas.length}}</span>
              </v-btn>
            </template>
          </SilenciarCategoria>
        </div>
      </template>

      <template #header.data-table-select>&nbsp;</template>

      <template #item.data-table-select="{item}">
        <div class="ml-2">
          <v-btn
            v-if="item.nivel_expancao ===  NIVEIS_DE_EXPANCAO.PRIMEIRO"
            icon small
            @click.stop="selecionarTodasCategorias(item)"
          >
            <v-icon v-if="categorias_selecionadas.length === 0">mdi-checkbox-blank-outline</v-icon>
            <v-icon v-else-if="categorias_selecionadas.length === CATEGORIAS.length" color="primary">mdi-checkbox-marked</v-icon>
            <v-icon v-else color="primary">mdi-minus-box</v-icon>
          </v-btn>

          <v-btn v-else icon small @click.stop="selecionarCategoria(item)">
            <v-icon v-if="categoriaEstaSelecionada(item)" color="primary">mdi-checkbox-marked</v-icon>
            <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
          </v-btn>
        </div>
      </template>

      <template #item.grupo="{item}">
        {{ item.sigla_grupo }}
      </template>

      <template #item.descricao_categoria="{item}">
        <div class="d-flex align-center">
          <DetalhamentoCategoria v-if="item.nivel_expancao ===  NIVEIS_DE_EXPANCAO.SEGUNDO" :categoria="item" />
          {{ item.descricao_categoria }}
        </div>
      </template>

      <template #item.idcategoria="{item}">
        {{ item.idcategoria || '-' }}
      </template>

      <template #item.nome_grupo_produto="{item}">
        {{ item.nome_grupo_produto || '-' }}
      </template>

      <template #item.cmm_pa="{item}">
        {{ formatarValor(item.cmm_pa) }}
      </template>

      <template #item.cmm_peso="{item}">
        {{ formatarValor(item.cmm_peso) }}
      </template>

      <template #item.estoque_pa="{item}">
        {{ formatarValor(item.estoque_pa) }}
      </template>

      <template #item.estoque_pa_peso="{item}">
        {{ formatarValor(item.estoque_pa_peso) }}
      </template>

      <template #item.estoque_mp_peso="{item}">
        {{ formatarValor(item.estoque_mp_peso) }}
      </template>

      <template #item.estoque_peso="{item}">
        <div class="d-flex align-center">
          <span v-text="formatarValor(item.estoque_peso)" />
          <EstoquePorFilial :parametros="{...item, grupo: GRUPO_COMPRA}" tipo_filiais="lojas">
            <template #topo-tabela>
              <DescricaoNivelLinha :linha="item" />
            </template>
          </EstoquePorFilial>
        </div>
      </template>

      <template #item.estoque_transito_peso="{item}">
        <div class="d-flex">
          {{ formatarValor(item.estoque_transito_peso) }}

          <PedidosPendente v-if="item.estoque_transito_peso > 0" :filtros="{...item, grupo: GRUPO_COMPRA}">
            <template #topo-tabela>
              <DescricaoNivelLinha :linha="item" />
            </template>
          </PedidosPendente>
        </div>
      </template>

      <template #item.cobertura_geral_dias="{item}">
        {{ `${formatarValorComCasas(item.cobertura_geral_dias, 1)} dias` }}
      </template>

      <template #item.prazo_medio_recebimento="{item}">
        {{ `${formatarValorComCasas(item.prazo_medio_recebimento, 1)} dias` }}
      </template>

      <template #item.ultima_entrada="{item}">
        <span v-if="!item.data_ultima_entrada" class="text-gray-100">sem entrada</span>
        <v-tooltip v-else open-delay="500" top>
          <template #activator="{ on, attrs }">
            <div class="d-flex">
              <span v-bind="attrs" v-on="on" v-text="`há ${item.qtd_dias_ultima_entrada} dias`" />

              <UltimasCompras :filtros="{...item, grupo: GRUPO_COMPRA}">
                <template #topo-tabela>
                  <DescricaoNivelLinha :linha="item" />
                </template>
              </UltimasCompras>
            </div>
          </template>

          <span v-text="`A última entrada foi feita em ${item.data_ultima_entrada}`" />
        </v-tooltip>
      </template>

      <template #item.ultima_venda="{item}">
        <span v-if="!item.data_da_ultima_venda" class="text-gray-100">sem venda</span>

        <v-tooltip v-else open-delay="500" top>
          <template #activator="{ on, attrs }">
            <div class="d-flex">
              <span v-bind="attrs" v-on="on" v-text="`há ${item.qtd_dias_ultima_venda} dias`" />

              <VendasUltimosMeses :filtros="{...item, grupo: GRUPO_COMPRA}">
                <template #topo-corpo>
                  <DescricaoNivelLinha class="pt-3 pl-2" :linha="item" />
                </template>
              </VendasUltimosMeses>
            </div>
          </template>
          <span v-text="`A última venda foi feita em ${item.data_da_ultima_venda}`" />
        </v-tooltip>
      </template>

      <template #item.cobertura_estoque_futura="{item}">
        <CalculaCoberturaEstoqueFutura
          :item="{
            estoque: item.estoque_peso,
            consumo_medio_mensal: item.cmm_peso,
            sugestao: item.sugestao_compra_peso,
            estoque_transito: item.estoque_transito_peso,
            tempo_medio_ressuprimento: item.tempo_medio_ressuprimento,
            multiplo_compra: 1
          }"
        />
      </template>

      <template #item.nivel_servico="{item}">
        <div v-if="item.idcategoria" class="d-flex align-center">
          <NivelServico
            :nivel_servico="item.nivel_servico"
            :label="`categoria de ${item.nivel_servico}`.toLocaleLowerCase()"
          />

          <SilenciarCategoria
            :idgrupo="Number(item.id_grupo)"
            :categorias="[item.idcategoria]"
            @categorias-silenciadas="categoriasSilenciadas()"
          />
        </div>
      </template>

      <template #item.sugestao_compra_peso="{item}">
        <AdicionaNoCarrinho v-if="item.idcategoria" :linha="item"
          @produto-adicionado-carrinho="produtoAdicionadoNoCarrinho([item])" />

        <div v-else class="text-center pr-11">
          {{ `${Helpers.formatarValor(QTD_TOTAL_SUGESTAO_COMPRA || 0)} ${item.idunidade_medida}` }}
        </div>
      </template>
    </SysDataTableDepartamentos>
  </MenuContexto>
</template>

<script>
import SysDataTableDepartamentos from '@/components/utils/dataTable/sysDataTableDepartamentos/Index.vue';
import NivelServico from "@/components/utils/dataTable/sysDataTableDepartamentos/Componentes/NivelServico";
import AdicionaNoCarrinho from './AcoesGrid/AdicionaNoCarrinho.vue';
import CalculaCoberturaEstoqueFutura from "../../../compra/CalculaCoberturaEstoqueFutura";
import PedidosPendente from "./DetalhesCategoria/Tabela/PedidosPendente.vue";
import UltimasCompras from "./DetalhesCategoria/Tabela/UltimasCompras.vue";
import VendasUltimosMeses from "./DetalhesCategoria/Tabela/VendasUltimosMeses.vue";
import EstoquePorFilial from "./DetalhesCategoria/Tabela/EstoquePorFilial.vue";
import DescricaoNivelLinha from "./Helpers/DescricaoNivelLinha.vue";
import * as requisicoes from '../../../../api/compras/MateriaPrima.js';
import {cabecalhos} from "./Cabecalhos.js";
import {card_selecionado} from "./Helpers/CardSelecionado.js";
import ResponsiveHeight from '../../../../helpers/ResponsiveHeight.js';
import {arrayColumn, formatarValor, formatarValorComCasas} from "@/helpers";
import {mapGetters} from "vuex";
import {categoria_selecionada} from "./Helpers/CategoriaSelecionado";
import {NIVEIS_DE_EXPANCAO} from "@/components/utils/dataTable/sysDataTableDepartamentos/NiveisDeExpancao";
import DetalhamentoCategoria from "@/components/compra/materiaPrima/compra/AcoesGrid/DetalhamentoCategoria";
import AdicionarMultiplasCategoriasAoCarrinho from "@/components/compra/materiaPrima/compra/AcoesGrid/AdicionarMultiplasCategoriasAoCarrinho";
import MenuContexto from "@/components/utils/MenuContexto";
import SilenciarCategoria from "@/components/compra/materiaPrima/compra/Silenciar/SilenciarCategoria.vue";

export default {
  name: "GridPrincipal",
  mixins: [ResponsiveHeight, card_selecionado, categoria_selecionada],
  components: {
    SilenciarCategoria,
    MenuContexto,
    AdicionarMultiplasCategoriasAoCarrinho,
    DetalhamentoCategoria,
    SysDataTableDepartamentos,
    NivelServico,
    AdicionaNoCarrinho,
    CalculaCoberturaEstoqueFutura,
    PedidosPendente,
    UltimasCompras,
    VendasUltimosMeses,
    EstoquePorFilial,
    DescricaoNivelLinha
  },
  props: {
    filtros_sys_categorias: Array
  },
  data: () => ({
    departamento_fake: 1,
    cabecalhos: cabecalhos,
    itens_grid: [],
    linhas_removidas: [],
    NIVEIS_DE_EXPANCAO,
    categorias_selecionadas: []
  }),
  computed: {
    ...mapGetters({
      'GRUPO_COMPRA': 'usuario/getGrupoCompras',
      'callbackAtualizarCarrinhoCompra': 'compraMateriaPrima/callbackAtualizarCarrinhoCompra',
      'callbackAtualizarGridCategorias': 'compraMateriaPrima/callbackAtualizarGridCategorias',
      'callbackAtualizarCardsTotais': 'compraMateriaPrima/callbackAtualizarCardsTotais',
      'callbackAtualizarQtdeCategoriasSilenciadas': 'compraMateriaPrima/callbackAtualizarQtdeCategoriasSilenciadas'
    }),
    VISAO_VERTICAL_ATIVA() {
      return this.$store.getters['CompraProdutosGerais/getVisaoVertical'];
    },
    PARAMETROS_REQUISICAO() {
      return {
        grupo: this.GRUPO_COMPRA,
        card: this.card_selecionado.chave || 'itens_a_comprar',
        filtros_sys_categorias: this.filtros_sys_categorias
      }
    },
    QTD_TOTAL_SUGESTAO_COMPRA() {
      const callback = (a, b) => {
        if (!b.idcategoria) {
          return a
        }

        return a + Number(b.sugestao_compra_peso);
      };

      return this.itens_grid.reduce(callback, 0)
    },
    CATEGORIAS() {
      return this.itens_grid.filter(item => item.nivel_expancao ===  NIVEIS_DE_EXPANCAO.SEGUNDO)
    }
  },
  watch: {
    PARAMETROS_REQUISICAO: {
      handler() {
        if (Number.isNaN(this.GRUPO_COMPRA)) return;

        this.linhas_removidas = [];
        this.callbackAtualizarGridCategorias();
      },
      deep: true
    }
  },
  methods: {
    formatarValor,
    formatarValorComCasas,
    async buscarTotalizadorCategoriasCompra() {
      const total_geral = await requisicoes.buscarTotalizadorCategoriasCompra(this.PARAMETROS_REQUISICAO);

      if (total_geral) {
        total_geral.linha_totalizadora = true;
      }

      return total_geral ? this.formatoLinha(total_geral) : undefined;
    },
    async buscarCategoriasCompra() {
      const categorias = await requisicoes.buscarCategoriasCompra(this.PARAMETROS_REQUISICAO)
      return categorias.map(this.formatoLinha);
    },
    formatoLinha(linha) {
      // iddepartamento e idsecao são necessarios para uso interno do grid
      linha.iddepartamento = this.departamento_fake;
      linha.idsecao = this.departamento_fake;
      return linha;
    },
    produtoAdicionadoNoCarrinho(produtos) {
      this.linhas_removidas.push(...produtos);
      this.categorias_selecionadas = [];
      this.callbackAtualizarCarrinhoCompra();
    },
    setCallbackAtualizarGridCategorias({callback}) {
      this.$store.dispatch("compraMateriaPrima/callbackAtualizarGridCategorias", callback);
    },
    setCategoriaSelecionada(linha) {
      if (linha.nivel_expancao !== NIVEIS_DE_EXPANCAO.SEGUNDO) return;
      this.categoria_selecionada = linha;
    },
    classesCssLinha(linha) {
      if (linha.nivel_expancao === NIVEIS_DE_EXPANCAO.PRIMEIRO) return {};

      const categoria_detalhamento = this.categoria_selecionada
        && this.categoria_selecionada.idcategoria === linha.idcategoria;

      return {
        'sys-data-table-gray-linha': categoria_detalhamento,
      };
    },
    categoriaEstaSelecionada(categoria) {
      const callback = item => item.idcategoria === categoria.idcategoria;
      return this.categorias_selecionadas.some(callback);
    },
    selecionarCategoria(categoria) {
      if (! this.categoriaEstaSelecionada(categoria)) {
        this.categorias_selecionadas.push(categoria);
        return;
      }

      const callback = item => item.idcategoria !== categoria.idcategoria;
      this.categorias_selecionadas = this.categorias_selecionadas.filter(callback);
    },
    selecionarTodasCategorias() {
      if (this.categorias_selecionadas.length === this.CATEGORIAS.length) {
        this.categorias_selecionadas = [];
        return;
      }

      this.categorias_selecionadas = this.CATEGORIAS;
    },
    atualizarCategoriasParaVincularAGruposProdutos() {
      this.$store.dispatch(
        "compraMateriaPrima/categorias_para_vincular_a_grupos_produtos",
        this.Helpers.arrayColumn(this.categorias_selecionadas, 'idcategoria'),
      );

      this.categorias_selecionadas = [];
    },
    categoriasSilenciadas() {
      this.categorias_selecionadas = [];
      this.callbackAtualizarGridCategorias();
      this.callbackAtualizarQtdeCategoriasSilenciadas();
      this.callbackAtualizarCardsTotais();
    }
  }
}
</script>
